import { isPlatformBrowser } from '@angular/common';
import { Component, inject, input, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ArrowComponent,
  DialogService,
  InternalSimStates,
  PlanStateNames,
  Sim,
  SimsService,
  SimStatesMapping,
  StateNames,
  StatusTagComponent,
  StorageService,
} from '@gb-webapp/gb-app';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-esim-selection-dialog',
  imports: [StatusTagComponent, TranslatePipe, ArrowComponent],
  templateUrl: './esim-selection-dialog.component.html',
  styleUrl: './esim-selection-dialog.component.scss',
})
export class EsimSelectionDialogComponent {
  private readonly dialogService = inject(DialogService);
  protected simsService = inject(SimsService);
  protected router = inject(Router);
  protected route = inject(ActivatedRoute);
  protected storageService = inject(StorageService);
  private readonly platformId = inject(PLATFORM_ID);

  public regionType = input.required<string>();
  public destinationSlug = input.required<string>();
  public planSlug = input.required<string>();
  public imsiId = input.required<string>();
  public inventoryAvailability = input.required<boolean>();

  public SimStatesMapping = SimStatesMapping;

  public PlanStateNames = PlanStateNames;

  public InternalSimStates = InternalSimStates;

  public StateNames = StateNames;

  closeModal(): void {
    this.dialogService.closeTopDialog();
  }

  storeEsimData(selectedEsim?: Sim): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const esimData = {
      esimId: selectedEsim?.esimId || null,
      iccid: selectedEsim?.iccid?.toString() || null,
      imsiId: selectedEsim?.imsiId?.toString() || null,
      name: selectedEsim?.name || null,
      isEsimSelected: !!selectedEsim?.esimId,
    };
    this.storageService.setEsimData(esimData);
  }

  goToCheckout(selectedEsim?: Sim) {
    this.storeEsimData(selectedEsim);

    this.closeModal();

    // Navigate to checkout using the slugs from input props
    this.router.navigate([`/${this.destinationSlug()}/${this.planSlug()}/checkout`]);
  }
}
